export default {
    orange: '#f48220',
    darkBlue: '#1f4a83',
    gray: '#ababac',
    maroon: '#a31f2d',
    pink: '#d06971'
}
